import ProductivityReportsAPI from '../../api/productivityReports';
import { downloadCsvFile } from '../../helper/downloadHelper';

const state = {
  uiFlags: {
    isFetching: false,
    fetchError: false,
    isFetchingTopContacts: false,
    isExporting: false,
    exportError: false,
  },
  summary: {
    conversations_participated: 0,
    avg_overall_response_time: 0,
    avg_first_response_time: 0,
    avg_next_response_time: 0,
    avg_resolution_time: 0,
    messages_sent: 0,
    messages_received: 0,
    resolutions_count: 0,
    transfers_out: 0,
    transfers_in: 0,
  },
  topContacts: [],
};

const getters = {
  getProductivitySummary: $state => $state.summary,
  getProductivityUIFlags: $state => $state.uiFlags,
  getProductivityTopContacts: $state => $state.topContacts,
  getProductivityIsExporting: $state => $state.uiFlags.isExporting,
};

const SET_PRODUCTIVITY_SUMMARY = 'SET_PRODUCTIVITY_SUMMARY';
const SET_PRODUCTIVITY_LOADING = 'SET_PRODUCTIVITY_LOADING';
const SET_PRODUCTIVITY_ERROR = 'SET_PRODUCTIVITY_ERROR';
const SET_PRODUCTIVITY_TOP_CONTACTS = 'SET_PRODUCTIVITY_TOP_CONTACTS';
const SET_PRODUCTIVITY_TOP_CONTACTS_LOADING =
  'SET_PRODUCTIVITY_TOP_CONTACTS_LOADING';
const SET_PRODUCTIVITY_EXPORTING = 'SET_PRODUCTIVITY_EXPORTING';
const SET_PRODUCTIVITY_EXPORT_ERROR = 'SET_PRODUCTIVITY_EXPORT_ERROR';

const actions = {
  async fetchProductivitySummary({ commit }, params) {
    commit(SET_PRODUCTIVITY_LOADING, true);
    commit(SET_PRODUCTIVITY_ERROR, false);
    try {
      const response = await ProductivityReportsAPI.getSummary(params);
      commit(SET_PRODUCTIVITY_SUMMARY, response.data);
    } catch {
      commit(SET_PRODUCTIVITY_ERROR, true);
    } finally {
      commit(SET_PRODUCTIVITY_LOADING, false);
    }
  },
  async exportProductivityReport({ commit }, { params, fileName }) {
    commit(SET_PRODUCTIVITY_EXPORTING, true);
    commit(SET_PRODUCTIVITY_EXPORT_ERROR, false);
    try {
      const response = await ProductivityReportsAPI.getExport(params);
      // Prepend UTF-8 BOM so Excel opens the file with correct encoding
      downloadCsvFile(fileName, '﻿' + response.data);
    } catch {
      commit(SET_PRODUCTIVITY_EXPORT_ERROR, true);
    } finally {
      commit(SET_PRODUCTIVITY_EXPORTING, false);
    }
  },
  async fetchProductivityTopContacts({ commit }, params) {
    commit(SET_PRODUCTIVITY_TOP_CONTACTS_LOADING, true);
    try {
      const response = await ProductivityReportsAPI.getTopContacts(params);
      commit(SET_PRODUCTIVITY_TOP_CONTACTS, response.data);
    } catch {
      commit(SET_PRODUCTIVITY_TOP_CONTACTS, []);
    } finally {
      commit(SET_PRODUCTIVITY_TOP_CONTACTS_LOADING, false);
    }
  },
};

const mutations = {
  [SET_PRODUCTIVITY_SUMMARY]($state, data) {
    $state.summary = { ...$state.summary, ...data };
  },
  [SET_PRODUCTIVITY_LOADING]($state, flag) {
    $state.uiFlags.isFetching = flag;
  },
  [SET_PRODUCTIVITY_ERROR]($state, flag) {
    $state.uiFlags.fetchError = flag;
  },
  [SET_PRODUCTIVITY_TOP_CONTACTS]($state, data) {
    $state.topContacts = data;
  },
  [SET_PRODUCTIVITY_TOP_CONTACTS_LOADING]($state, flag) {
    $state.uiFlags.isFetchingTopContacts = flag;
  },
  [SET_PRODUCTIVITY_EXPORTING]($state, flag) {
    $state.uiFlags.isExporting = flag;
  },
  [SET_PRODUCTIVITY_EXPORT_ERROR]($state, flag) {
    $state.uiFlags.exportError = flag;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
